import { Fragment, ReactNode } from 'react';

type Props = {
    readonly content: ReactNode[];
    readonly separator: ReactNode;
};

export function JoinReactNodes({ content, separator }: Props): ReactNode {
    return (
        <>{content
            .filter(Boolean)
            .flatMap((node, index) => (index === 0
                // eslint-disable-next-line react/no-array-index-key
                ? <Fragment key={index}>{node}</Fragment>
                // eslint-disable-next-line react/no-array-index-key
                : <Fragment key={index}>{separator}{node}</Fragment>))}
        </>
    );
}
